module.exports = __webpack_public_path__ + "static/img/huan-zai-jin.a45110a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/huan-zai-jin.jpg
// module id = PugC
// module chunks = 1